var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_33145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.5H6.7575",
    stroke: "#5674DE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5H11.2575",
    stroke: "#5674DE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 11.4373C7.36941 11.1878 7.66114 10.9897 7.9831 10.8544C8.30505 10.7191 8.65077 10.6494 9 10.6494C9.34923 10.6494 9.69495 10.7191 10.0169 10.8544C10.3389 10.9897 10.6306 11.1878 10.875 11.4373",
    stroke: "#5674DE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1743 13.2045C12.9698 13.415 12.8314 13.6809 12.7765 13.9692C12.7216 14.2576 12.7524 14.5557 12.8653 14.8267C12.9782 15.0976 13.168 15.3295 13.4114 15.4936C13.6548 15.6577 13.941 15.7468 14.2345 15.7499C14.528 15.7529 14.8159 15.6698 15.0627 15.5107C15.3094 15.3517 15.504 15.1238 15.6225 14.8552C15.7409 14.5866 15.7779 14.2892 15.729 13.9998C15.68 13.7104 15.5473 13.4417 15.3471 13.227L14.2498 12L13.1743 13.2045Z",
    stroke: "#5674DE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6488 10.1378C15.7148 9.76207 15.7487 9.38144 15.75 9C15.75 7.66498 15.3541 6.35994 14.6124 5.2499C13.8707 4.13987 12.8165 3.27471 11.5831 2.76382C10.3497 2.25292 8.99252 2.11925 7.68314 2.3797C6.37377 2.64015 5.17104 3.28303 4.22703 4.22703C3.28303 5.17104 2.64015 6.37377 2.3797 7.68314C2.11925 8.99252 2.25292 10.3497 2.76382 11.5831C3.27471 12.8165 4.13987 13.8707 5.2499 14.6124C6.35994 15.3541 7.66498 15.75 9 15.75C9.5175 15.75 10.02 15.693 10.5 15.5835",
    stroke: "#5674DE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_33145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSad);
export default __webpack_public_path__ + "static/media/icon-sad.22712ba835fe210687724795a3287551.svg";
export { ForwardRef as ReactComponent };